import React, { useEffect, useState } from 'react'
import { SearchBar } from "components/form";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaEye } from "react-icons/fa";
import { userListApi } from "services/user";
import useDebounce from "common/UseDebounce";
import NotFound from "common/NotFound";
import findSerialNumber from "utils/findSerialNumber";
import { limitOption } from "constants/staticData";
import {
    firstWordCapital,
    getValueOrFallback,
} from "utils/common";
import DeleteWarning from "./DeleteWarning";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { dateFormat } from "utils/dateFormat";
import ChangeSelectedUserStatus from './ChangeSelectedUserStatus';
import ViewReport from './ViewReport';
import { getReportListApi } from 'services/report';
import { MdDelete } from "react-icons/md";
import TypographyLimit from 'components/TypographyLimit';
import useUser from 'hooks/useUser';

const MessageReport = () => {
    const { havePermission } = useUser();
    const [searchParams, setSearchParams] = useSearchParams();
    const [userList, setUserList] = useState([]);
    const [search, setSearch] = useState("");
    const debouncedValue = useDebounce(search, 300);
    const [loader, onShow, onHide] = useFullPageLoader();
    const userTypeValue = searchParams.get("userType") || "";
    const activePage = +searchParams.get("page") || 1;
    const limits = +searchParams.get("limit") || 10;
    const [total, setTotal] = useState(null);
    const [selectedUserDetail, setSelectedUserDetail] = useState({});
    const [deleteModel, setDeleteModel] = useState(false);
    const [userStatusModal, setUserStatusModal] = useState(false);
    const [state, setState] = useState({
        status: "",
        viewDetail: {
            isModalOpen: false,
            _id: ""
        },
        deleteWarning: {
            isModalOpen: false,
            _id: "",
        }
    });

    const userListHandler = async (activePage, limits) => {
        try {
            onShow();
            const reqData = {
                pagination: "true",
                page: activePage,
                limit: limits,
                type: "COMMENT",
                ...(search && debouncedValue && { search: debouncedValue })
            };
            const { data, status } = await getReportListApi(reqData);
            if (status === 200) {
                setTotal(data?.meta.totalRecords);
                setUserList(data?.data);
            }
        } catch (e) {
            console.log(e);
        } finally {
            onHide();
        }
    };


    const onClose = () => {
        setSelectedUserDetail({});
        setUserStatusModal(false);
        setDeleteModel(false);
    };

    // handle limit of page
    const handleLimit = (event) => {
        searchParams.set("limit", event.target.value);
        searchParams.delete("page");
        setSearchParams(searchParams);
    };

    // Handle pagination
    const handlePageChange = (event) => {
        searchParams.set("page", event);
        setSearchParams(searchParams);
    };

    // change user Status handler
    const changeUserStatusHandler = (data) => {
        setUserStatusModal(true)
        setSelectedUserDetail(data)
    }

    useEffect(() => {
        if (Number(activePage) === 1) {
            searchParams.delete("page");
            setSearchParams(searchParams);
        }
        userListHandler(activePage, limits);
    }, [searchParams, activePage, debouncedValue, userTypeValue, limits, state?.status]);

    useEffect(() => {
        if (debouncedValue) {
            searchParams.delete("page");
        }
    }, [debouncedValue]);

    console.log({ userList });



    return (
        <div>
            <div className="button_section_wrap">
                <div className="search_wrapper">
                    <SearchBar
                        placeholder={"Search..."}
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                    />
                </div>
            </div>

            {/* Table With Pagination  */}
            <div className="card">
                <div className="card-body">
                    <div className="table_wrap ">
                        <table className="table custom_table">
                            <thead>
                                <tr>
                                    <th className="nowrap text-center">S.No</th>
                                    <th className="nowrap text-center">Comment</th>
                                    <th className="nowrap text-center">Comment By</th>
                                    <th className="nowrap text-center">Report Count</th>
                                    <th className="nowrap text-center">Last Report Date</th>
                                    <th className="nowrap text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loader}
                                {userList && userList.length ? (
                                    userList?.map((data, index) => {
                                        console.log({ data });

                                        return (
                                            <tr key={index}>
                                                <td className="nowrap text-center">
                                                    {findSerialNumber(index, activePage, limits)}
                                                </td>
                                                <td className="nowrap text-center">
                                                    {
                                                        <TypographyLimit text={data?._comment?.content} limit={20} />
                                                    }
                                                </td>
                                                <td className="nowrap text-center">
                                                    {getValueOrFallback(data?._comment?._user?.fullName || "")}
                                                </td>
                                                <td className="nowrap text-center">
                                                    {data?.reportCount}
                                                </td>
                                                <td className="nowrap text-center">
                                                    {dateFormat(data?.lastReport?.createdAt)}
                                                </td>
                                                <td>
                                                    <div className="icon_wrap">
                                                        <Link
                                                            // to={`user-detail/${data._id}`}
                                                            onClick={() => {
                                                                setState(prev => ({
                                                                    ...prev,
                                                                    viewDetail: {
                                                                        ...prev.viewDetail,
                                                                        isModalOpen: true,
                                                                        _id: data?._id
                                                                    }
                                                                }))
                                                            }}
                                                            className="icon_button"
                                                        >
                                                            <FaEye />
                                                        </Link>
                                                        {
                                                            havePermission("report.write") &&
                                                            <Link
                                                            to=""
                                                            className="icon_button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                changeUserStatusHandler(data);
                                                            }}
                                                        >
                                                            {data?._comment?.status === "ACTIVE" ? (
                                                                <CgBlock style={{ color: "red" }} />
                                                            ) : (
                                                                <CgUnblock />
                                                            )}
                                                        </Link>}
                                                        {
                                                            havePermission("report.delete") &&
                                                            <Link
                                                            // to={`user-detail/${data._id}`}
                                                            onClick={() => {
                                                                setState((prev) => ({
                                                                    ...prev,
                                                                    deleteWarning: {
                                                                        ...prev.deleteWarning,
                                                                        isModalOpen: true,
                                                                        _id: data?._id,
                                                                    },
                                                                }));
                                                            }}
                                                            className="icon_button"
                                                        >
                                                            <MdDelete />
                                                        </Link>}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <NotFound
                                        cols={10}
                                        msg={"User Data not found"}
                                        onHide={onHide}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination-wrapper">
                        <div className="Pagination">
                            <select
                                className="input form-control"
                                value={limits}
                                onChange={handleLimit}
                            >
                                {limitOption &&
                                    limitOption.length > 0 &&
                                    limitOption.map((limitValue) => (
                                        <option key={limitValue.value} value={limitValue.value}>
                                            {limitValue.label}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    {total > limits && (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={limits}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>


            {/* ViewReport */}
            {
                state.viewDetail.isModalOpen &&
                <ViewReport
                    _id={state.viewDetail._id}
                    onClose={() => {
                        setState(prev => ({
                            ...prev,
                            viewDetail: {
                                ...prev.viewDetail,
                                isModalOpen: false,
                                _id: ""
                            }
                        }))
                    }}
                />
            }

            {/* Change User Status*/}
            {userStatusModal && (
                <ChangeSelectedUserStatus
                    selectedUserDetail={selectedUserDetail}
                    onClose={() => onClose()}
                    setUserList={setUserList}
                    userStatusModal={userStatusModal}
                    refetchUserList={() => userListHandler(activePage, limits)}
                />
            )}

            {/* Delete User  */}
            {state.deleteWarning._id && (
                <DeleteWarning
                    selectedUserDetail={state.deleteWarning._id}
                    onClose={() => {
                        setState((prev) => ({
                            ...prev,
                            deleteWarning: {
                                ...prev.deleteWarning,
                                isModalOpen: false,
                                _id: "",
                            },
                        }));
                    }}
                    deleteModel={state.deleteWarning.isModalOpen}
                    refetchUserList={() => userListHandler(activePage, limits)}
                />
            )}

        </div>
    )
}

export default MessageReport;